export const comorbidites: Option[] = [
  { value: "NEGLIGENCE", display: "Négligence" },
  { value: "APHASIE", display: "Aphasie" },
  { value: "ALEXIE", display: "Alexie" },
  { value: "AGNOSIE", display: "Agnosie" },
  { value: "SIMULTAGNOSIE", display: "Simultagnosie" },
  { value: "TROUBLE_EXECUTIF", display: "Trouble exécutif" },
  { value: "OPHTALMIQUE", display: "Ophtalmique" },
];

export const typeHLHOptions: Option[] = [
  { value: "TOTALE_DROITE", display: "Totale droite" },
  { value: "TOTALE_GAUCHE", display: "Totale gauche" },
  { value: "BILATERALE", display: "Bilatérale" },
  { value: "QSD", display: "QSD" },
  { value: "QID", display: "QID" },
  { value: "QSG", display: "QSG" },
  { value: "QIG", display: "QIG" },
];

export const lateralisationLesionOptions: Option[] = [
  { value: "GAUCHE", display: "Gauche" },
  { value: "DROITE", display: "Droite" },
  { value: "BILATERAL", display: "Bilatéral" },
];

export const localisationLesionOptions: Option[] = [
  { value: "PARIETAL", display: "Pariétal" },
  { value: "OCCIPITAL", display: "Occipital" },
  { value: "FRONTAL", display: "Frontal" },
  { value: "TEMPORAL", display: "Temporal" },
  { value: "NOYAUX_CENTRAUX", display: "Noyaux centraux" },
  { value: "AUTRES", display: "Autres" },
];

export const typeLesionOptions: Option[] = [
  { value: "ISCHEMIQUE", display: "Ischémique" },
  { value: "HEMORRAGIQUE", display: "Hémorragique" },
  { value: "AUTRES", display: "Autres" },
];

export const lateralityOptions: Option[] = [
  { value: "GAUCHE", display: "Gauche" },
  { value: "DROITE", display: "Droite" },
  { value: "AMBIDEXTRE", display: "Ambidextre" },
];

export type Option = {
  value: string;
  display: string;
};